import { render } from "./CensusRow.vue?vue&type=template&id=7ac3a2f0&scoped=true"
import script from "./CensusRow.vue?vue&type=script&lang=js"
export * from "./CensusRow.vue?vue&type=script&lang=js"

import "./CensusRow.vue?vue&type=style&index=0&id=7ac3a2f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac3a2f0"]])

export default __exports__